import { ExtraData } from '@src/@types/analytics';
import { ContactDetails } from '@src/constants/phone-numbers';
import { useAnalytics } from '@src/hooks/use-analytics.hook';

export const PhoneNumberLink = ({
  contact,
  analyticsEventLabel,
  analyticsExtraData,
}: {
  contact: ContactDetails;
  analyticsEventLabel?: string;
  analyticsExtraData?: ExtraData;
}) => {
  const { trackEvent } = useAnalytics();
  const { link, label, phoneNumber } = contact;

  return (
    <a
      href={link}
      title={`Call ${label}`}
      onClick={() => {
        if (analyticsEventLabel && analyticsExtraData) {
          trackEvent({
            eventCategory: 'petInsurance',
            eventAction: 'click',
            eventLabel: analyticsEventLabel,
            extraData: analyticsExtraData,
          });
        }
      }}
    >
      {phoneNumber}
    </a>
  );
};
